import { useState, useEffect } from 'react';
import { adminService, AdminStats } from '../services/adminService';

// This endpoint is Owner-only — pass `enabled: false` for any other role
// so the hook doesn't poll a request that's guaranteed to 403.
export const useAdminStats = (refreshInterval: number = 30000, enabled: boolean = true) => {
  const [stats, setStats] = useState<AdminStats | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string>('');

  const fetchStats = async () => {
    try {
      setError('');
      const data = await adminService.getAdminStats();
      setStats(data);
    } catch (err: any) {
      // Only set error if it's not a permission error (non-super admin)
      if (err.response?.status !== 403) {
        setError(err.response?.data?.detail || 'Failed to load admin stats');
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!enabled) {
      setLoading(false);
      return;
    }

    fetchStats();

    // Set up polling for real-time updates
    const interval = setInterval(fetchStats, refreshInterval);

    return () => clearInterval(interval);
  }, [refreshInterval, enabled]);

  return {
    stats,
    loading,
    error,
    refetch: fetchStats,
  };
};
